import { domToReact } from 'html-react-parser';
import { RenderElement } from '@capgroup-cxt/aem-react-utils/lib/hooks/htmlParser/interfaces';
const renderBold: RenderElement = (props) => {
    const { domNode, options } = props;
    const { children } = domNode;
    return <b> {domToReact(children, options)}</b>;
};

export default renderBold;
